const indexItems = [
  {
    title: '动作电影精选',
    desc: '肾上腺素飙升的视觉盛宴',
    count: '326部',
    icon: 'ri-knife-blood-line',
    color: 'primary',
  },
  {
    title: '喜剧电影合集',
    desc: '承包你一整天的好心情',
    count: '258部',
    icon: 'ri-emotion-laugh-line',
    color: 'accent',
  },
  {
    title: '科幻大片专场',
    desc: '探索未来与未知世界',
    count: '189部',
    icon: 'ri-rocket-line',
    color: 'secondary',
  },
  {
    title: '爱情电影特辑',
    desc: '甜蜜与感动的情感之旅',
    count: '215部',
    icon: 'ri-heart-line',
    color: 'primary',
  },
  {
    title: '恐怖惊悚之夜',
    desc: '挑战你的心理承受极限',
    count: '143部',
    icon: 'ri-ghost-line',
    color: 'accent',
  },
  {
    title: '动画电影大全',
    desc: '全年龄段精彩动画作品',
    count: '201部',
    icon: 'ri-palette-line',
    color: 'secondary',
  },
  {
    title: '纪录纪实频道',
    desc: '真实故事的力量与震撼',
    count: '167部',
    icon: 'ri-camera-lens-line',
    color: 'primary',
  },
  {
    title: '院线新片速递',
    desc: '最新上映热门院线大片',
    count: '92部',
    icon: 'ri-movie-2-line',
    color: 'accent',
  },
];

export default function IndexSection() {
  const getColorClasses = (color: string) => {
    switch (color) {
      case 'primary':
        return {
          bg: 'bg-primary-50',
          icon: 'text-primary-600',
          border: 'border-primary-200',
        };
      case 'accent':
        return {
          bg: 'bg-accent-50',
          icon: 'text-accent-600',
          border: 'border-accent-200',
        };
      case 'secondary':
        return {
          bg: 'bg-secondary-50',
          icon: 'text-secondary-600',
          border: 'border-secondary-200',
        };
      default:
        return {
          bg: 'bg-primary-50',
          icon: 'text-primary-600',
          border: 'border-primary-200',
        };
    }
  };

  return (
    <section id="index" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading mb-3">
            主题索引
          </h2>
          <p className="text-sm text-foreground-600 max-w-lg mx-auto">
            按主题快速定位你想看的电影分类，一键直达精彩内容
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {indexItems.map((item, i) => {
            const colors = getColorClasses(item.color);
            return (
              <div
                key={i}
                className={`group flex items-start gap-4 p-5 rounded-xl ${colors.bg} border ${colors.border} hover:shadow-sm transition-all duration-200 cursor-pointer`}
              >
                <div className={`w-10 h-10 flex-shrink-0 flex items-center justify-center rounded-lg ${colors.bg}`}>
                  <i className={`${item.icon} ${colors.icon} text-lg`}></i>
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="text-sm font-semibold text-foreground-900 mb-1 font-heading whitespace-nowrap">
                    {item.title}
                  </h3>
                  <p className="text-xs text-foreground-600 mb-1.5">{item.desc}</p>
                  <span className="text-xs text-foreground-500 whitespace-nowrap">{item.count}</span>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}